import { FuseNavigation } from '@fuse/types';
import { environment } from '@env/environment';

const profileUrl = `${environment.stsUrl}user`;
const eDocketsURL= `${environment.eDocketsURL}`;
const smartDocketsURL= `${environment.smartDocketsURL}`;
const formWorkFlowURL= `${environment.formWorkFlowURL}`;
const docketAlertsURL= `${environment.docketAlertsURL}`;
export const navigation: FuseNavigation[] = [
    {
        id       : 'efiling-dash',
        title    : 'e-Filing',
        translate: 'NAV.EFILE.TITLE',
        type     : 'group',
        icon     : 'dash',
        children : [
            {
                id       : 'dashboard',
                title    : 'Dashboard',
                translate: 'NAV.DASHBOARD.TITLE',
                type     : 'item',
                icon     : 'dashboard',
                url      : '/dashboard' ,
                display:true  
            },
            {
                id      : 'new-case',
                title   : 'New Case Filing',
                type    : 'item',
                url     : '/new-filing',
                icon    : 'note_add',
                display:true
            },
            {
                id      : 'subsequent',
                title   : 'Subsequent Filing',
                type    : 'item',
                url     : '/subsequent/filing',
                icon    : 'description',
                display:true
            },
            // {
            //     id       : 'search-transaction',
            //     title    : 'Search Transactions',
            //     translate: 'NAV.SEARCH.TITLE',
            //     type     : 'item',
            //     icon     : 'search',
            //     url      : '/sample'
            // },
            // {
            //     id       : 'drafts',
            //     title    : 'Drafts',
            //     translate: 'NAV.DRAFTS.TITLE',
            //     type     : 'item',
            //     icon     : 'email',
            //     url      : '/drafts/detail'
            // },            
            {
                id       : 'billing',
                title    : 'Billing & Reports',
                translate: 'NAV.BILLING.TITLE',
                type     : 'item',
                icon     : 'money',
                url      : '/billing-reports',
                display:true
            },
            // {
            //     id       : 'concierge',
            //     title    : 'Concierge',
            //     translate: 'NAV.CONCIERGE.TITLE',
            //     type     : 'item',
            //     icon     : 'room_service',
            //     url      : '/services/concierge',
            //     hidden   : false,
            // },
            // {
            //     id       : 'conciergeService',
            //     title    : 'Concierge Service',
            //     translate: 'NAV.CS.TITLE',
            //     type     : 'collapsable',
            //     icon     : 'room_service',
            //     hidden   : true,
            //     children: [
            //         {
            //             id       : 'wq',
            //             title    : 'Work Queue',
            //             translate: 'NAV.WQ.TITLE',
            //             type     : 'item',
            //             url      : '/services/concierge-work-queue',
            //             icon     : 'inbox'
            //         },
            //         {
            //             id       : 'wh',
            //             title    : 'Work History',
            //             translate: 'NAV.WH.TITLE',
            //             type     : 'item',
            //             url      : '/services/concierge-work-history',
            //             icon     : 'history'
            //         },
            //     ]
            // },
            {
                id       : 'faq',
                title    : 'FAQ',
                translate: 'NAV.FAQ.TITLE',
                type     : 'item',
                icon     : 'help',
                url      : '/pages/faq'
            },
            {
            id       : 'enterprise',
            title    : 'Enterprise Suite',
            translate: 'NAV.ENTERPRISE.TITLE',
            type     : 'group',
            display:true,
            children : [                
                    // {
                    //     id       : 'mail',
                    //     title    : 'Mail',
                    //     translate: 'NAV.MAIL.TITLE',
                    //     type     : 'item',
                    //     icon     : 'email',
                    //     url      : '/mail',
                    //     /* openInNewTab : true, */
                    //     externalUrl : true
                    // },            
                    // {
                    //     id       : 'calendar',
                    //     title    : 'Calendar',
                    //     translate: 'NAV.CALENDAR.TITLE',
                    //     type     : 'item',
                    //     icon     : 'today',                
                    //     url      : '/calendar',
                    //     /* openInNewTab : true, */
                    //     externalUrl : true
                    // },
                    // {
                    //     id       : 'aln-products',
                    //     title    : 'Products',
                    //     translate: 'NAV.PRODUCTS.TITLE',
                    //     type     : 'collapsable',                               
                    //     icon     : 'apps',                     
                    //     children: [
                                {
                                    id       : 'aln-eDockets',
                                    title    : 'eDockets ®',
                                    translate: 'NAV.ALNEDOC.TITLE',
                                    type     : 'item',
                                   // url      : 'https://edockets.alncorp.com',
                                    url         : eDocketsURL,
                                    icon: 'queue_play_next',
                                    openInNewTab: true,
                                    externalUrl: true,
                                    display:true
                                },
                                // {
                                //     id       : 'smart-dockets',
                                //     title    : 'Smart Dockets ®',
                                //     translate: 'NAV.SMARTDOCK.TITLE',
                                //     type     : 'item',
                                //    // url      : 'http://smartdockets.com',
                                //     url         : smartDocketsURL,
                                //     icon: 'fiber_smart_record',
                                //     openInNewTab: true,
                                //     externalUrl: true,
                                //     display:true
                                // },
                                {
                                    id       : 'forms-workflow',
                                    title    : 'Forms Workflow ®',
                                    translate: 'NAV.FORMSWF.TITLE',
                                    type     : 'item',
                                   // url      : 'http://formsworkflow.com',
                                    url         : formWorkFlowURL,
                                    icon: 'find_in_page',
                                    openInNewTab: true,
                                    externalUrl: true,
                                    display:true
                                },
                                
                                {
                                    id       : 'docket-alerts',
                                    title    : 'Docket Alerts ®',
                                    translate: 'NAV.DOCKETALERTS.TITLE',
                                    type     : 'item',
                                    //url      : 'http://docketalerts.com',
                                    url         : docketAlertsURL,
                                    icon: 'format_textdirection_l_to_r',
                                    openInNewTab: true,
                                    externalUrl: true,
                                    display:true
                                }
                           // ]
                   // }
                ]
            },

            {
                id       : 'aln-productmanagement',
                title    : 'ADMINISTRATION TOOLS',
                translate: 'NAV.PRODUCTMANAGEMENT.TITLE',
                type     : 'group',
                display:true,
                children: [
                    {
                        id       : 'aln-Admin',
                        title    : 'Settings',
                        translate: 'NAV.ADMIN.TITLE',
                        type     : 'collapsable',                               
                        icon     : 'admin_panel_settings',   
                        // hidden   : true, 
                        display:true,                 
                        children: [
                            // {
                            //     id       : 'administration',
                            //     title    : 'Manage Firm Users',
                            //     translate: 'NAV.ADMIN.TITLE',
                            //     type     : 'item',
                            //     // icon     : 'supervised_user_circle',
                            //     url      : '/user-management',
                            //     hidden   : true
                            // }
                            // ,
                            {
                                id       : 'attorneys',
                                title    : 'Manage Firm Attorneys',
                                translate: 'NAV.ADMIN.TITLE',
                                type     : 'item',
                               // icon     : 'money',
                                url      : '/firm-management',
                                display:true
                                
                            },  
                            {
                                id       : 'billing',
                                title    : 'Billing Administration',
                                translate: 'NAV.BILLING.TITLE',
                                type     : 'item',
                                // icon     : 'monetization_on',
                                url      : '/billing-management',
                                hidden   : true,
                                display:true
                            },
                            {
                                id       : 'settings',
                                title    : 'App Settings',
                                translate: 'NAV.SETTINGS.TITLE',
                                type     : 'item',
                                // icon     : 'monetization_on',
                                url      : '/settings',
                                hidden   : true,
                                display:true
                            },
                            // {
                            //     id       : 'order',
                            //     title    : 'Update Order',
                            //     translate: 'NAV.ORDER.TITLE',
                            //     type     : 'item',
                            //     //icon     : 'file_copy',
                            //     url      : '/order-update',
                            //     hidden   : true
                            // },                            
                            {
                                id       : 'firmPayment',
                                title    : 'Manage Firm Payment',
                                translate: 'NAV.MANAGEFIRMPAYMENT.TITLE',
                                type     : 'item',
                                url      : '/manage-firm-payment',
                                hidden   : true,
                                display:true
                            }
                            
                            
                        ]
                    },
                    {
                        id          : 'profile',
                        title       : 'Profile',
                        translate   : 'NAV.PROFILE.TITLE',
                        type        : 'item',
                        icon        : 'person_outline',
                        url         : profileUrl,
                        externalUrl : true,
                    }   ,
                    
                    {
                        id          : 'tyManagement',
                        title       : 'Manage Registrations',
                        translate   : 'NAV.TYMANAGEMENT.TITLE',
                        type        : 'item',   
                        icon        : 'edit',                     
                        url         : '/manage-tyler-registrations',
                        hidden   : false,
                        display:true
                    }     
                ]
            }
        ]
    }
];

